const rankingItems = [
  { rank: 1, title: '星际迷航：新纪元', type: '科幻', hot: '892万', trend: 'up', score: '9.2' },
  { rank: 2, title: '极限追击', type: '动作', hot: '756万', trend: 'up', score: '9.0' },
  { rank: 3, title: '长安十二时辰', type: '古装', hot: '689万', trend: 'up', score: '8.8' },
  { rank: 4, title: '深海迷城', type: '冒险', hot: '623万', trend: 'stable', score: '8.5' },
  { rank: 5, title: '月光变奏曲', type: '爱情', hot: '541万', trend: 'up', score: '8.3' },
  { rank: 6, title: '迷雾追踪', type: '悬疑', hot: '487万', trend: 'down', score: '8.6' },
];

const featureItems = [
  {
    icon: 'ri-4k-line',
    title: '4K蓝光画质',
    desc: '全站资源支持4K超清与蓝光原盘画质，HDR色彩还原真实细腻，带来家庭影院级别的视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速缓冲不卡顿',
    desc: '全球CDN节点智能调度，自适应码率技术确保任何网络环境下流畅播放，告别缓冲等待。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告体验',
    desc: '全程无弹窗、无贴片广告干扰，专注观影本身。所有资源经过安全审核，放心观看。',
  },
];

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="text-xs font-label text-accent-400 uppercase tracking-wider">实时热度</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">热门榜单</h2>
        </div>
        <div className="bg-background-100/60 border border-background-200/40 rounded-lg overflow-hidden">
          <div className="hidden sm:grid grid-cols-12 gap-4 px-5 py-3 border-b border-background-200/40 text-xs text-foreground-500 font-label">
            <span className="col-span-1">排名</span>
            <span className="col-span-4">影片</span>
            <span className="col-span-2">类型</span>
            <span className="col-span-2">热度</span>
            <span className="col-span-2">趋势</span>
            <span className="col-span-1">评分</span>
          </div>
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-2 sm:grid-cols-12 gap-2 sm:gap-4 px-5 py-4 border-b border-background-200/20 last:border-b-0 hover:bg-background-200/30 transition-colors cursor-pointer items-center"
            >
              <div className="sm:col-span-1 flex items-center gap-1">
                <span className={`text-sm font-label font-bold ${
                  item.rank <= 3 ? 'text-accent-400' : 'text-foreground-500'
                }`}>{item.rank}</span>
              </div>
              <div className="sm:col-span-4">
                <p className="text-sm text-foreground-800 font-label font-medium">{item.title}</p>
              </div>
              <div className="sm:col-span-2">
                <span className="text-xs text-foreground-500 font-label">{item.type}</span>
              </div>
              <div className="sm:col-span-2">
                <span className="text-xs text-primary-400 font-label">{item.hot}</span>
              </div>
              <div className="sm:col-span-2 flex items-center gap-1">
                <i className={`text-xs ${
                  item.trend === 'up' ? 'ri-arrow-up-line text-accent-400' :
                  item.trend === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                  'ri-subtract-line text-foreground-400'
                }`}></i>
                <span className="text-xs text-foreground-500 font-label">
                  {item.trend === 'up' ? '上升' : item.trend === 'down' ? '下降' : '稳定'}
                </span>
              </div>
              <div className="sm:col-span-1">
                <span className="text-xs text-foreground-700 font-label font-medium">{item.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/40">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="text-xs font-label text-primary-400 uppercase tracking-wider">关于我们</span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1 mb-4">关于90影视</h2>
            <div className="space-y-3 text-sm text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              <p>
                90影视是一个专注于高清影视资源聚合与分享的在线平台，致力于为广大影视爱好者提供极致的观影体验。
                我们聚合海量高清超清4K蓝光1080P画质的电影电视剧资源，涵盖动作、悬疑、科幻、喜剧、爱情、纪录等全品类内容。
              </p>
              <p>
                平台每日同步更新最新院线大片与热门剧集，无需注册即可免费在线观看。
                依托全球CDN加速与自适应码率技术，确保在任何网络环境下都能实现流畅无缓冲播放。
              </p>
              <p>
                90影视坚持纯净无广告的观影理念，所有资源经过严格安全审核。
                我们相信，好的影视内容值得用最好的画质呈现，让每一位用户都能享受家庭影院级别的视听盛宴。
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-xs lg:max-w-sm">
            <div className="rounded-lg overflow-hidden aspect-square bg-background-100/50 border border-background-200/40">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20home%20cinema%20room%20with%20large%20projector%20screen%20displaying%20cinematic%20content%2C%20comfortable%20recliner%20chairs%2C%20warm%20ambient%20lighting%2C%20dark%20acoustic%20wall%20panels%2C%20luxurious%20theater%20atmosphere%2C%20golden%20accent%20details%2C%20premium%20home%20entertainment%20setup&width=600&height=600&seq=about-90movies&orientation=squarish"
                alt="90影视 - 家庭影院级观影体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-accent-400 uppercase tracking-wider">为什么选择我们</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">平台优势</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100/60 border border-background-200/40 rounded-lg p-6 text-center hover:border-primary-500/20 transition-colors cursor-pointer group"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function RankingAboutGroup() {
  return (
    <>
      <RankingSection />
      <AboutSection />
      <FeaturesSection />
    </>
  );
}